// extracted by mini-css-extract-plugin
export default {"ResultsNotFoundMessage":"ResultsNotFoundMessage__ResultsNotFoundMessage___wjwwv","message":"ResultsNotFoundMessage__message___wClda"};